export var CVC = 'cvc';
export var NUMBER = 'number';
export var EXPIRY = 'expiry';
export var NAME = 'name';